import React from 'react';

import { Box, TextButton } from '@zillow/constellation-10';
import { IconExternalOutline } from '@zillow/constellation-icons';

import { RMWContext } from '../../../../providers/RMWContext';
import propertyUtils from '../../../../utils/propertyUtils';
import type { LISTING_SUMMARY_DISPLAY_STATUS } from '../../../../constants/ListingSummaryConstants';

const pmrResultsBasePath = 'rental-manager/price-my-rental/results/';

type Address = {
  street: string;
  city: string;
  state: string;
  unit: string;
  name?: string;
  zip: string;
};

type Props = {
  address: Address;
  status: keyof typeof LISTING_SUMMARY_DISPLAY_STATUS;
  hasAnalyticsRentComps?: boolean;
};

const CompsCTA = ({ address, hasAnalyticsRentComps }: Props) => {
  const { paths } = React.useContext(RMWContext);

  const { formattedKebobCase: pmrResultsAddress } = propertyUtils.formatAddress(address);
  const pmrHref = hasAnalyticsRentComps
    ? paths.zillowPriceRentalLandingPage
    : `${pmrResultsBasePath}${pmrResultsAddress}/`;
  const pmrUrl = new URL(pmrHref, 'https://www.zillow.com/');
  address.unit && pmrUrl.searchParams.set('unit', address.unit);

  const ctaText = hasAnalyticsRentComps ? 'Get rent comps' : 'Compare to your property';

  return (
    <Box css={{ display: 'flex', justifyContent: 'center', marginTop: '400' }}>
      <TextButton asChild icon={<IconExternalOutline />} iconPosition="end">
        <a href={pmrUrl.toString()} target="_blank" rel="noreferrer">
          {ctaText}
        </a>
      </TextButton>
    </Box>
  );
};

export default CompsCTA;
